import { useState } from 'react';
import { Badge } from '@/components/ui/badge';
import { PHOTO_WALL } from './retreatsData';

export const PhotoWall = () => {
  const [lightbox, setLightbox] = useState(null);

  return (
    <section id="moments" className="py-20 px-6 bg-white" data-testid="photo-wall-section">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <Badge className="bg-forest/10 text-forest mb-4">Real Women. Real Moments.</Badge>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-forest mb-4">
            This Is What Just Being Looks Like.
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Not staged. Not performed. Just women — laughing, resting, praying, crying, dancing, and being witnessed.
          </p>
        </div>

        <div className="columns-2 md:columns-3 lg:columns-4 gap-4 [&>img]:mb-4">
          {PHOTO_WALL.map((img) => (
            <img
              key={img}
              src={img}
              alt="A Just Be retreat moment"
              className="w-full rounded-xl cursor-pointer hover:opacity-90 hover:scale-[1.02] transition-all duration-300 shadow-sm break-inside-avoid"
              loading="lazy"
              onClick={() => setLightbox(img)}
            />
          ))}
        </div>
      </div>

      {lightbox && (
        <div
          className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4 animate-in fade-in duration-200"
          onClick={() => setLightbox(null)}
          data-testid="photo-wall-lightbox"
        >
          <button
            className="absolute top-4 right-4 text-white hover:text-terracotta transition-colors z-10 text-4xl leading-none"
            onClick={() => setLightbox(null)}
            aria-label="Close"
            data-testid="lightbox-close-btn"
          >
            ×
          </button>
          <img
            src={lightbox}
            alt="Retreat moment enlarged"
            className="max-w-full max-h-[90vh] object-contain rounded-lg shadow-2xl animate-in zoom-in-95 duration-200"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </section>
  );
};
